import { Controller } from "@hotwired/stimulus"

// Classes used by Tailwind JIT scanner: w-16 w-64 md:pl-16 md:pl-64
const CLASSES = {
  expanded:  { sidebar: "w-64",  content: "md:pl-64" },
  collapsed: { sidebar: "w-16",  content: "md:pl-16" },
}

export default class extends Controller {
  static targets = ["sidebar", "content", "label", "iconLogo"]

  connect() {
    if (localStorage.getItem("sidebar_collapsed") === "true") {
      this._apply(true)
    }
  }

  toggle() {
    const collapsed = !this.sidebarTarget.classList.contains("w-64")
    this._apply(!collapsed)
    localStorage.setItem("sidebar_collapsed", (!collapsed).toString())
  }

  _apply(collapse) {
    const add = collapse ? CLASSES.collapsed : CLASSES.expanded
    const remove = collapse ? CLASSES.expanded : CLASSES.collapsed

    this.sidebarTarget.classList.remove(remove.sidebar)
    this.sidebarTarget.classList.add(add.sidebar)
    this.contentTarget.classList.remove(remove.content)
    this.contentTarget.classList.add(add.content)

    if (collapse) {
      this.sidebarTarget.classList.add("sidebar-collapsed")
      this.labelTargets.forEach(el => el.classList.add("hidden"))
      if (this.hasIconLogoTarget) this.iconLogoTarget.classList.remove("hidden")
    } else {
      this.sidebarTarget.classList.remove("sidebar-collapsed")
      this.labelTargets.forEach(el => el.classList.remove("hidden"))
      if (this.hasIconLogoTarget) this.iconLogoTarget.classList.add("hidden")
    }
  }
}
